import { useNavigate } from 'react-router-dom'

import { prefetchQuery } from '../../../../Services/QueryCache'
import { cap } from '../../../../State'
import { translations } from '../../../../translations'

const language = cap.language.state || 'IT'
const t = translations[language] || translations.IT

/**
 * Bottoni azione per ogni riga della tabella conversazioni.
 * Include il bottone "Vedi dettaglio" e un indicatore di warning per stati anomali.
 * @param {Object} props - Proprietà del componente
 * @param {number|string} props.id - ID della conversazione
 * @param {boolean} props.hasWarning - Se la conversazione ha un indicatore di warning
 * @returns {JSX.Element} Componente azioni conversazione
 */
export function ConversationActions({ id, hasWarning }) {
  const navigate = useNavigate()

  /**
   * Gestisce la navigazione al dettaglio della conversazione
   * @param {Event} e - Evento click
   */
  const handleNavigate = (e) => {
    e.stopPropagation()
    navigate('/operatore/' + id)
  }

  return (
    <div className="gigi-actions-cell">
      <button
        type="button"
        className="naction-btn naction-btn--primary"
        aria-label={t.viewDetail}
        title={t.open}
        onClick={handleNavigate}
        onMouseEnter={() => prefetchQuery(['conversation', id?.toString()])}
      >
        <i className="pi pi-eye" style={{ fontSize: 15 }} />
      </button>
      <span className="gigi-actions-warning-slot">
        {hasWarning && (
          <span
            className="gigi-actions-warning"
            title={t.warningConversationPending}
            aria-label={t.conversationPending}
          >
            <i className="pi pi-exclamation-circle" />
          </span>
        )}
      </span>
    </div>
  )
}
